export default {
  xl: "40px",
  lg: "28px",
  md: "26px",
  sm: "24px",
  body: "18px",
  caption: "16px",
  xs: "14px",
};
